module.exports = __webpack_public_path__ + "static/media/1.1c36c10a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16100/1.jpg
// module id = 533
// module chunks = 0